var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='2' height='14' viewBox='0 0 2 14' fill='none'%3e %3cpath d='M1.29199 1V13' stroke='%23B7B7B7' stroke-linecap='round'/%3e%3c/svg%3e";
  export default img;